import React, { PropsWithChildren } from 'react';
import { Link } from 'react-router-dom';
import { identifyComponent } from '../../util';
import { Text } from '../Text';
import css from './Breadcrumbs.module.scss';

export interface BreadcrumbItemProps {
  testId?: string;
  /**
   * Path in which this Breadcrumb link will navigate. Same interface as React
   * Router's Link. If `to` is undefined, it is assumed to be the current page.
   */
  to?: React.ComponentProps<typeof Link>['to'];
}

export const BreadcrumbItem: React.FC<PropsWithChildren<BreadcrumbItemProps>> = ({
  testId = 'breadcrumb-item',
  to,
  children,
}) => {
  const isCurrentPage = to === undefined;
  const sharedProps: React.ComponentProps<typeof Text> = {
    className: css.breadcrumbLink,
    appearance: 'bodySmall',
    color: isCurrentPage ? 'default' : 'secondary',
    'aria-current': isCurrentPage ? 'page' : undefined,
    children,
  };

  return (
    <li
      data-component="BreadcrumbItem"
      className={css.breadcrumbItem}
      data-testid={testId}
      {...identifyComponent('breadcrumb-item')}
    >
      {to ? <Text {...sharedProps} tag={Link} to={to} /> : <Text {...sharedProps} tag="span" />}
    </li>
  );
};
